"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseQueryString;

var _getQueryString = _interopRequireDefault(require("./getQueryString"));

var cachedQueryString;

function parseQueryString() {
  try {
    if (cachedQueryString) {
      return cachedQueryString;
    }

    var search = (0, _getQueryString.default)();
    var pairs = search.slice(1).split('&');
    var result = {};
    pairs.forEach(function (pair) {
      pair = pair.split('=');
      result[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    cachedQueryString = result;
    return result;
  } catch (e) {
    return {};
  }
}

module.exports = exports.default;